import { createVNode as _createVNode, vShow as _vShow, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d52822f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "no-favorite-card"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($props.favoriteLines.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          class: "card-view-container",
          key: $props.allCardsUpdateKey
        }, [
          _createVNode($setup["CardSwiper"], {
            ref: "cardSwiper",
            updateKey: $props.cardUpdateKey,
            favoriteLines: $props.favoriteLines,
            shouldCurrentCardShowFront: $setup.shouldShowFront,
            onBoardLine: $props.onBoardLine,
            onOnSlideChange: $setup.onSlideChange,
            onOnClickLineInfo: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goToLineInfoDetail'))),
            onOnClickBusStopLocation: $setup.emitOnClickBusStopLocation,
            onUpdateBusLocation: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('updateBusLocation'))),
            onOnChangedCheck: $setup.onChangedCheck,
            onOnClickScheduleBtn: $setup.emitOnShowTimeTable,
            onOnClickReportBtn: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleShowReportModal(true))),
            onOnClickBusImage: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleShowBusImage(true)))
          }, null, 8 /* PROPS */, ["updateKey", "favoriteLines", "shouldCurrentCardShowFront", "onBoardLine"]),
          _withDirectives((_openBlock(), _createBlock($setup["MainCardButton"], {
            class: "bus-stop--location",
            key: $props.cardUpdateKey,
            isBusRunning: $props.isBusRunning,
            shouldShowFront: $setup.shouldShowFront,
            onOnClickMainCardButton: $setup.onClickMainCardButton
          }, null, 8 /* PROPS */, ["isBusRunning", "shouldShowFront"])), [
            [_vShow, !$setup.isInsideShuttle]
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode($setup["NoFavoriteCard"], { onOnClickSearch: $setup.goToSearch })
        ])),
    ($setup.shouldShowReportModal)
      ? (_openBlock(), _createBlock($setup["ReportModal"], {
          key: 2,
          boardUid: $props.currentFavoriteLine?.boardUid ?? '',
          lineName: $setup.lineName,
          lineStartTime: $props.currentFavoriteLine?.lineStartTime ?? '-',
          busPlateNumber: $props.currentFavoriteLine?.boardedCarNo ?? '-',
          onOnClickCloseBtn: _cache[4] || (_cache[4] = ($event: any) => ($setup.toggleShowReportModal(false)))
        }, null, 8 /* PROPS */, ["boardUid", "lineName", "lineStartTime", "busPlateNumber"]))
      : _createCommentVNode("v-if", true),
    ($setup.shouldShowBusImage)
      ? (_openBlock(), _createBlock($setup["BusInfoModal"], {
          key: 3,
          buses: $props.currentFavoriteLine?.buses ?? [],
          onOnClickClose: _cache[5] || (_cache[5] = ($event: any) => ($setup.toggleShowBusImage(false)))
        }, null, 8 /* PROPS */, ["buses"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}